import { put, takeLatest, call } from "redux-saga/effects";
import * as memberAction from "../actions/ActionCreator";
import * as memberType from "../actions/ActionType";
import { API_ENDPOINT } from "../URLs/ApiEndpoints";
import * as Api from "../../appApi/AppApi";

const TAG = "GeneratedOTP";

function* workerGenerateOtp(payLoad) {
  console.log("Generate OTP payload: ", payLoad)  
  try {
    const response = yield call(
      Api.makeNewSecuredPostRequest,
      API_ENDPOINT.GENERATE_OTP,
      payLoad.data  
    );
    yield put(memberAction.createActionOf(memberType.GENERATE_OTP_SUCCESS, 1, response));
  } catch (error) {
    yield put(memberAction.createActionOf(memberType.GENERATE_OTP_FAILED, 2, error));
  }
}

export const watchGenerateOtp = takeLatest(
  memberType.GENERATE_OTP,
  workerGenerateOtp
);